<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 64px);
  padding: 20px 24px 28px;
  overflow: hidden;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue